export default __webpack_public_path__ + "static/media/turquoise-bg-mobile.21b62bf5.svg";